import React from 'react';
import Title from './Title';
import Channels from './Channels';

const ChannelWrapper = ({ list, title, sub, type, popUp, setId }) => {
  return (
    <div className="mb-8">
      <Title list={list} title={title} sub={sub} type={type} />
      <Channels list={list} type={type} popUp={() => popUp?.()} setId={state => setId?.(state)} />
      <div className="border-b border-gray-700 mt-8" />
    </div>
  );
};

export default ChannelWrapper;
